import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getZipCodes,
  guestLogin,
  getPlans,
  setLoginStateParams,
  yearSelection,
  setStateParams,
  setLoginStateValues,
  resetStore,
} from "../../../Redux/Actions/webAppActions";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import SimpleReactValidator from "simple-react-validator";
import history from "../../../Utils/History";
import { Text } from "react-internationalization";
/*
Landing screen of @Sharp web application.
setSnackbar is a utility method for snackbar.
*/
const SharpUserLogin = () => {
  const [state, setState] = useState({
    email_address: "",
    phone_number: "",
    zip_code: "",
    plan_year: "",
    displayCounty: false,
    county: "",
    snackBarOpen: false,
    alertMsg: "",
    severity: "",
    vertical: "center",
    horizontal: "center",
  });
  const validator = new SimpleReactValidator();
  const { zipCodes, language, year } = useSelector((state1) => state1.webApp);
  const {
    customerId,
    userId,
    token,
    customerSubdomainDetails,
    theme,
    subDomain,
    pcpSubscription,
  } = useSelector((state2) => state2.login);

  const dispatch = useDispatch();
  useEffect(() => {
    window.scroll(0, 0);
    window.sessionStorage.setItem("customerId", customerId);
    window.sessionStorage.setItem("language", language);
    window.sessionStorage.setItem(
      "customerSubdomainDetails",
      JSON.stringify(customerSubdomainDetails)
    );
    window.sessionStorage.setItem("theme", theme);
    window.sessionStorage.setItem("pcpSubscription", pcpSubscription);
    window.sessionStorage.setItem("subDomain", subDomain);
    dispatch(resetStore());
    dispatch(
      setStateParams("language", window.sessionStorage.getItem("language"))
    );
    dispatch(setStateParams("selectedPlansForCompare", []));
    let loginValuesreset = {
      subDomain: window.sessionStorage.getItem("subDomain"),
      theme: window.sessionStorage.getItem("theme"),
      pcpSubscription: window.sessionStorage.getItem("pcpSubscription"),
      customerId: window.sessionStorage.getItem("customerId"),
    };
    dispatch(setLoginStateValues(loginValuesreset));
    dispatch(
      setLoginStateParams(
        "customerSubdomainDetails",
        JSON.parse(window.sessionStorage?.getItem(customerSubdomainDetails))
      )
    );
  }, []);
  const handleChange = async (e) => {
    let name = e.target.name;
    let value = e.target.value;
    switch (name) {
      case "plan_year": {
        setState({ ...state, [name]: value });
        dispatch(yearSelection(value));
        break;
      }
      case "zip_code": {
        //replacing all characters other than digit using regEx
        value = value.replace(/[^0-9]+/g, "");
        setState({ ...state, [name]: value });
        if (value.length === 5) {
          //when zip code is of length 5 then making api call
          await dispatch(
            guestLogin({
              username: email_address,
              customerId: customerId,
            })
          );
          const resp = await dispatch(getZipCodes(value));
          if (resp.status === "OK") {
            let county1 = "";
            if (resp?.data?.length === 1) {
              county1 = resp?.data[0]?.countyName;
            }
            let obj = { [name]: value, displayCounty: true, county: county1 };
            setState({ ...state, ...obj });
            window.sessionStorage.setItem("zipcode", value);
          } else {
            let obj = {
              [name]: value,
              displayCounty: false,
              county: "",
              snackBarOpen: true,
              alertMsg: resp.message,
              severity: "error",
            };
            setState({ ...state, ...obj });
          }
        }
        break;
      }
      case "phone_number": {
        value = value.replace(/[^0-9]+/g, "");
        setState({ ...state, [name]: value });
        break;
      }
      default: {
        setState({ ...state, [name]: value });
        break;
      }
    }
  };
  const setSnackbar = (snackBarOpen1, alertMsg1, severity1) => {
    setState({
      ...state,
      snackBarOpen: snackBarOpen1,
      alertMsg: alertMsg1,
      severity: severity1,
    });
  };
  const getPlanHandler = async () => {
    const emailError = !validator.check(email_address, "email");
    if (emailError && email_address !== "") {
      let msg =
        language === "en"
          ? "Please enter valid email address."
          : "Por favor ingrese una dirección de correo electrónico válida.";
      setSnackbar(true, msg, "error");
      return;
    }
    const phoneError =
      phone_number === "" ? false : phone_number.length < 10 ? true : false;
    if (phoneError) {
      let msg1 =
        language === "en"
          ? "Please enter valid Phone Number."
          : "Ingrese un número de teléfono válido.";
      setSnackbar(true, msg1, "error");
      return;
    }
    if (email_address !== "" && email_address !== userId) {
      await dispatch(
        guestLogin({
          username: email_address,
          customerId: customerId,
        })
      );
    }
    if (zip_code !== "" && plan_year !== "" && county !== "") {
      let data = zipCodes.filter((x) => x.countyName === county)[0];
      const response = await dispatch(
        getPlans(
          zip_code,
          data.countyCode,
          customerId,
          data.stateCode,
          year?.planYear ? year.planYear : year
        )
      );
      if (response?.status != "OK") {
        let msg = response?.message
          ? response?.message
          : response?.data?.message;
        setSnackbar(true, msg, "error");
        setTimeout(() => {
          history.push("/e-Enroll/userLogin");
        }, 2000);
        return;
      }
      if (response.status === "OK") {
        window.sessionStorage.setItem("token", token);
        window.sessionStorage.setItem("guestLogin", true);
        window.sessionStorage.setItem("agentLoggedIn", false);
        window.sessionStorage.setItem("beneficiaryLogin", false);
        window.sessionStorage.setItem("userId", email_address);
        window.sessionStorage.setItem("countySelect", county);
        window.sessionStorage.setItem(
          "year",
          year?.planYear ? year.planYear : year
        );
        history.push("/e-Enroll/select-plan");
      } else {
        let msg3 = language === "en" ? "System Error." : "Error del sistema.";
        setSnackbar(true, msg3, "error");
      }
    } else {
      let msg2 =
        language === "en"
          ? "Please fill all mandatory fields."
          : "Por favor, complete todos los campos obligatorios.";
      setSnackbar(true, msg2, "error");
    }
  };
  const {
    email_address,
    phone_number,
    zip_code,
    plan_year,
    displayCounty,
    county,
    snackBarOpen,
    alertMsg,
    severity,
    vertical,
    horizontal,
  } = state;
  return (
    <main className="main-content-area bg-white" id="main-content">
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={6000}
        onClose={() =>
          setState({
            ...state,
            snackBarOpen: false,
          })
        }
        anchorOrigin={{ vertical, horizontal }}
        key={vertical + horizontal}
      >
        <Alert
          onClose={() =>
            setState({
              ...state,
              snackBarOpen: false,
            })
          }
          severity={severity}
        >
          {alertMsg}
        </Alert>
      </Snackbar>
      <div className="container-fluid container-xxl" id="page-wrap">
        <div className="panel-box">
          <div className="row">
            <div className="col-12 col-md-7 order-2 order-md-1 mt-3">
              <h2>
                <Text id="sharp.ourPlan" />
              </h2>
              <p>
                <Text id="sharp.loginPara" />
              </p>
              <div className="form-container">
                <form>
                  <div className="form-container mb-3">
                    <label htmlFor="email_address" className="form-label">
                      <Text id="sharp.email" />
                    </label>
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      id="email_address"
                      name="email_address"
                      type="email"
                      className="form-control"
                      // placeholder={language==="es"?"(Opcional)":"(Optional)"}
                      value={email_address}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                  <div className="form-container mb-3">
                    <label htmlFor="phone_number" className="form-label">
                      <Text id="sharp.ph" />
                    </label>
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      id="phone_number"
                      name="phone_number"
                      type="text"
                      className="form-control"
                      // placeholder={language==="es"?"(Opcional)":"(Optional)"}
                      value={phone_number}
                      onChange={(e) => handleChange(e)}
                      maxLength="10"
                    />
                  </div>
                  <div className="form-container mb-3">
                    {/* {zip_code.length !== 5 && (
                      <div
                        className="error-msg"
                        // style={{ display: "none" }}
                      >
                        Please type correct zipcode and select county
                      </div>
                    )} */}
                    <div className="zipcode-container">
                      <div>
                        <label htmlFor="zip_code" className="form-label">
                          <Text id="sharp.zip" />
                          <span className="mandatory-field">*</span>
                        </label>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="text"
                          id="zip_code"
                          name="zip_code"
                          className={
                            zip_code.length === 5
                              ? "form-control"
                              : "error-input"
                          }
                          value={zip_code}
                          maxLength="5"
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                      {displayCounty === true && zip_code.length === 5 && (
                        <div
                          className="ms-2"
                          id="county_container"
                          // style={{ display: "none" }}
                        >
                          <label htmlFor="county" className="form-label">
                            <Text id="sharp.county" />
                            <span className="mandatory-field">*</span>
                          </label>
                          <select
                            id="county"
                            name="county"
                            type="text"
                            className={
                              county === ""
                                ? "form-select error-input"
                                : "form-select"
                            }
                            aria-label="Select county"
                            onChange={(e) => handleChange(e)}
                            value={county}
                          >
                            <option value="" key="select">
                              {language === "es"
                                ? "Seleccionar condado"
                                : "Select county"}
                            </option>
                            {zipCodes?.map((x) => (
                              <option value={x.countyName} key={x.countyName}>
                                {x.countyName}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="form-container mb-3">
                    {/* {plan_year === "" && (
                      <div className="error-msg">Please select Plan year</div>
                    )} */}
                    <label htmlFor="plan_year" className="form-label">
                      <Text id="sharp.yr" />
                      <span className="mandatory-field">*</span>
                    </label>
                    <select
                      id="plan_year"
                      name="plan_year"
                      type="text"
                      className={
                        plan_year === ""
                          ? "form-select error-input"
                          : "form-select"
                      }
                      aria-label="Select plan year"
                      value={plan_year}
                      onChange={(e) => handleChange(e)}
                    >
                      <option value="">
                        {language === "es" ? "Seleccionar año" : "Select Year"}{" "}
                      </option>
                      <option value={new Date().getFullYear()}>
                        {new Date().getFullYear()}
                      </option>
                      {/* <option value={new Date().getFullYear()+1}>
                        {new Date().getFullYear()+1}
                      </option> */}
                      {new Date().getMonth() >= 9 && (
                        <option value={new Date().getFullYear() + 1}>
                          {new Date().getFullYear() + 1}
                        </option>
                      )}
                    </select>
                  </div>
                  <button
                    type="button"
                    className="btn-shp btn-shp-default"
                    onClick={getPlanHandler}
                  >
                    <Text id="sharp.viewPln" />
                  </button>
                </form>
              </div>
            </div>
            <div className="col-12 col-md-5 order-1 order-md-2 mt-3 mt-md-5">
              <div className="image1" />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
export default SharpUserLogin;
